import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "../contexts/AuthContext";
import MainLoader from "../layout/MainLoader";

/**
 * Landing após logout do Cognito (logout_uri).
 * Sem sessão local: vai direto para a tela de login.
 * Com sessão (edge): executa logout completo (API + Hosted UI) como em "Sair".
 */
export default function SsoLogoffPage() {
    const auth = useAuthContext();

    useEffect(() => {
        if (auth.isAuthenticated) {
            void auth.logout();
        }
    }, [auth.isAuthenticated, auth.logout]);

    if (!auth.isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    if (auth.isLoggingOut) {
        return null;
    }

    return <MainLoader />;
}
